
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34068',
  depVersions: {
  "documents-public-ui": "static-1.34068",
  "client-types": "static-1.450",
  "documents-lib": "static-1.34073",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1966",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5432",
  "hs-test-utils": "static-1.7845",
  "hub-http": "static-1.6057",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11280",
  "I18n": "static-7.1581",
  "jasmine-immutable": "static-1.2856",
  "jasmine-runner": "static-1.6309",
  "lodash": "static-1.3",
  "quartz": "static-1.6783",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16490",
  "reporting-data": "static-1.66686",
  "reporting-testing-lib": "static-1.8619",
  "reporting-visualizations": "static-1.58762",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4605",
  "webpack-env": "static-1.54",
  "atom": "static-1.4909",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2329",
  "classnames": "static-2.10",
  "cssUtils": "static-1.745",
  "customer-data-filters-ui": "static-1.39043",
  "customer-data-objects": "static-1.7487",
  "customer-data-property-utils": "static-1.7918",
  "data-fetching-client": "static-1.9516",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4370",
  "flux-actions": "static-1.312",
  "FormsCommonComponents": "static-1.85385",
  "FormUrlGenerator": "static-2.4560",
  "foundations-components": "static-1.7598",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11588",
  "icons": "static-2.627",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6998",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3695",
  "property-translator": "static-1.5248",
  "quartz-config": "static-1.561",
  "quartz-core": "static-1.6002",
  "quick-fetch": "static-1.3776",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5212",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8001",
  "reference-resolvers-lite": "static-1.7923",
  "report-customization-components": "static-1.12624",
  "reporting-enablement": "static-1.22214",
  "reporting-reports": "static-1.66364",
  "reporting-snowflake": "static-1.55304",
  "reporting-ui-components": "static-2.63957",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4476",
  "sales-content-partitioning": "static-1.8774",
  "SalesContentIndexUI": "static-3.8957",
  "sanitize": "static-1.4313",
  "sanitize-text": "static-1.7984",
  "self-service-api": "static-1.10079",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1589",
  "signup-constants": "static-1.18500",
  "signup-ui-lego-core": "static-1.20510",
  "signup-ui-url-generator": "static-2.7874",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4609",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10832",
  "ui-addon-i18n": "static-1.10983",
  "ui-addon-react-router-dom": "static-1.9384",
  "ui-addon-upgrades": "static-9.17709",
  "ui-asset-management-lib": "static-1.10758",
  "ui-images": "static-2.1107",
  "UIComponents": "static-3.8227",
  "usage-tracker": "static-1.7174",
  "usage-tracker-container": "static-1.7164",
  "usage-tracker-core": "static-1.7024",
  "usage-tracker-public": "static-1.6985",
  "viral-links-lib": "static-1.6878",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3267",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3060",
  "quartz-webpack": "static-1.3007",
  "ai-components-ui-library": "static-1.8456",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4679",
  "foundations-theming": "static-1.4250",
  "quartz-auth": "static-1.458",
  "ui-business-units-lib": "static-1.8870",
  "usage-tracker-session-replay": "static-1.4860",
  "foundations-theming-base": "static-1.3235",
  "HeadJS": "static-2.719",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2956",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4165",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7763",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3458",
  "persist-promise": "static-1.3547",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.623",
  "hs-story-utils": "static-1.9265",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9564",
  "hubspotter-http": "static-1.4516",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7087",
  "crm-message-bus": "static-1.42479",
  "customer-data-filters-ui-msw-helpers": "static-1.21478",
  "customer-data-objects-ui-components": "static-1.12850",
  "customer-data-reference-ui-components": "static-1.12986",
  "customer-data-ui-utilities": "static-1.9663",
  "framework-builder-read-service-client": "static-1.3871",
  "framework-data-schema-quick-fetch": "static-1.6616",
  "framework-data-schema-resolvers": "static-1.6711",
  "inbound-db-properties-service-client": "static-1.3712",
  "multi-account-reference-resolvers": "static-1.812",
  "onboarding-tours": "static-1.16317",
  "reporting-datasets-permissions-lib": "static-1.13170",
  "ui-addon-teams": "static-1.21291",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67735",
  "customer-data-properties": "static-1.50879",
  "forms-ai-lib": "static-1.4066",
  "forms-utils-lib": "static-1.12237",
  "foundations-components-test-utils": "static-1.5081",
  "react-dnd-compat": "static-1.4459",
  "react-tinymce": "static-1.54727",
  "tinymce-config": "static-2.53853",
  "ui-gdpr-components": "static-1.10186",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3867",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1319",
  "ui-fonts": "static-1.542",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.804",
  "mobile-manifest-mixins": "static-1.492",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.448",
  "quartz-i18n": "static-1.458",
  "quartz-routing": "static-1.213",
  "quartz-test": "static-1.458",
  "quartz-tracking": "static-1.162",
  "batch-promise": "static-1.1390",
  "external-options-client-types": "static-1.4022",
  "react-colorpicker": "static-2.10050",
  "copilot-toolkit": "static-1.10630",
  "data-quality-ui-library": "static-1.12412",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6302",
  "reporting-action-components": "static-1.40753",
  "reporting-insights-lib": "static-1.1217",
  "reporting-plugins": "static-1.10024",
  "ui-addon-draggable-compat": "static-2.4093",
  "ui-addon-opt": "static-4.8224",
  "ui-shepherd-react": "static-3.9985",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24836",
  "hubspot-apollo-client": "static-1.4719",
  "sales-templates-service-types-lib": "static-1.4030",
  "merchandise-lib": "static-1.260",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5528",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3943",
  "timezone-utils": "static-2.5083",
  "bender-build-tools": "static-1.2988",
  "chatspot-core": "static-1.20485",
  "chirp-fetch": "static-1.1721",
  "bend-plugin-foundations-theming": "static-1.2733",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9562",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3661",
  "crm-pipelines-api-client-types": "static-1.4003",
  "multi-currency-client-types": "static-1.3554",
  "getting-started-shared-tasks": "static-1.17989",
  "growth-data-modal": "static-1.5197",
  "growth-onboarding-confetti": "static-1.2911",
  "growth-onboarding-next-action-utils": "static-1.1394",
  "navigation-components": "static-1.17401",
  "onboarding-tours-client": "static-1.4531",
  "onboarding-tours-utils": "static-1.383",
  "ui-shepherd-tracker": "static-1.7366",
  "ui-universal-auth": "static-1.8755",
  "user-context": "static-1.4939",
  "cms-field-types": "static-1.4647",
  "content-icons-ui": "static-1.2169",
  "integrations-lib": "static-1.15553",
  "calling-global-api": "static-1.63806",
  "calling-internal-common": "static-1.31134",
  "calling-lifecycle-internal": "static-1.65188",
  "calling-lifecycle-messages": "static-1.57482",
  "commerce-products-lib": "static-1.8960",
  "crm-links": "static-1.6106",
  "file-manager-components": "static-1.23015",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.520",
  "inbounddb-objects-service-types": "static-1.4086",
  "meetings-icalendar-utils-lib": "static-1.471",
  "object-builder-ui-client": "static-1.48126",
  "pipeline-validation-client-types": "static-1.3827",
  "property-value-citations": "static-1.1493",
  "pulse": "static-1.355",
  "smart-property-lib": "static-1.6091",
  "tiered-pricing": "static-1.884",
  "ui-addon-iframeable": "static-1.8886",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19536",
  "tinymce-themes": "static-1.55823",
  "data-token-picker": "static-1.16108",
  "hub-http-contrib": "static-1.2882",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39938",
  "tinymce-plugins": "static-1.56967",
  "ui-addon-sales-email": "static-1.5053",
  "magpie-lib": "static-1.5433",
  "magpie-types": "static-1.4893",
  "simple-logging-lib": "static-1.2889",
  "content-assistance-lib": "static-1.7505",
  "dashboard-lib": "static-1.80783",
  "ExportDialog": "static-6.10227",
  "hubspot-prosemirror": "static-1.17706",
  "hubspot-prosemirror-plugins": "static-1.17698",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8532",
  "campaign-roi-lib": "static-1.8400",
  "feedback-loader": "static-1.28941",
  "apollo-link-hub-http": "static-2.4490",
  "hubspot-apollo-cache": "static-1.178",
  "growth-monetization-service-types": "static-1.4338",
  "nav-client-types": "static-1.2196",
  "purchase-motions-api": "static-1.5531",
  "trials-service-types": "static-1.3739",
  "growth-onboarding-next-action-components": "static-1.1422",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.564",
  "unified-auth-core-lib": "static-1.550",
  "getting-started-shared-tasks-store": "static-1.17107",
  "integrations-error-boundary-lib": "static-1.12968",
  "integrations-tracking-lib": "static-1.5427",
  "native-integrations-shared-strings": "static-1.7627",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10212",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31140",
  "shared-worker-versioning": "static-1.10878",
  "calling-usage-tracker": "static-1.6380",
  "voice-sms-access-library": "static-1.359",
  "customer-data-tracking": "static-1.6721",
  "commerce-permissions": "static-1.600",
  "products-iframe-lib": "static-1.7432",
  "products-ui-components-shared-msw-handlers": "static-1.9946",
  "location-customization-utils-lib": "static-1.8682",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3993",
  "video-components-external": "static-1.10683",
  "video-data-lib": "static-1.34341",
  "directed-graph": "static-1.778",
  "event-emitter": "static-1.786",
  "breeze-intelligence-kit": "static-1.5379",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9647",
  "fsm": "static-1.3570",
  "policy-lib": "static-1.6616",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9710",
  "navigation-messaging": "static-1.6728",
  "FileManagerLib": "static-1.38655",
  "NamespacedHubStyle": "static-2.8934",
  "FileManagerCore": "static-1.38514",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12108",
  "layout-dnd-utils": "static-1.11083",
  "react-codemirror": "static-1.10465",
  "ui-addon-emoji-picker": "static-1.9726",
  "ui-brand-identity-lib": "static-1.14147",
  "ui-addon-video-player": "static-1.8535",
  "ui-coaching-tips": "static-1.28046",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8406",
  "payment-link-components": "static-1.23042",
  "EmailSignatureEditor": "static-1.23979",
  "eligibility-engine-service-types": "static-1.3020",
  "universal-page-editor-lib": "static-1.2837",
  "calling-orchestration-schema": "static-1.35136",
  "sales-views-client-types": "static-1.4125",
  "crm-record-cards-service-types": "static-1.3481",
  "content-media-composition-data-lib": "static-1.11587",
  "content-media-compositions": "static-2.15594",
  "media-bridge-lib": "static-1.18630",
  "trellis-story-utils": "static-1.4359",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5669",
  "FileManagerImages": "static-1.36166",
  "video-components": "static-1.12686",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4370",
  "video-embed": "static-1.35175",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67810",
  "layout-data-lib": "static-1.9408",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6420",
  "commerce-tours-lib": "static-1.5773",
  "growth-onboarding-reliability": "static-1.4925",
  "sales-checkout-service-client": "static-1.3506",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21373",
  "sales-email-signature-service-client": "static-1.3682",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21470",
  "outpost": "static-1.4040",
  "advanced-menus-core": "static-1.14874",
  "advanced-menus-lib": "static-1.11844",
  "ui-memberships-settings-lib": "static-1.33553",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14873",
  "simple-menus-lib": "static-1.16390"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34068",
  "client-types": "/client-types/static-1.450",
  "documents-lib": "/documents-lib/static-1.34073",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1966",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5432",
  "hs-test-utils": "/hs-test-utils/static-1.7845",
  "hub-http": "/hub-http/static-1.6057",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11280",
  "I18n": "/I18n/static-7.1581",
  "jasmine-immutable": "/jasmine-immutable/static-1.2856",
  "jasmine-runner": "/jasmine-runner/static-1.6309",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6783",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16490",
  "reporting-data": "/reporting-data/static-1.66686",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8619",
  "reporting-visualizations": "/reporting-visualizations/static-1.58762",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4605",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4909",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2329",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.745",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39043",
  "customer-data-objects": "/customer-data-objects/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7918",
  "data-fetching-client": "/data-fetching-client/static-1.9516",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4370",
  "flux-actions": "/flux-actions/static-1.312",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85385",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4560",
  "foundations-components": "/foundations-components/static-1.7598",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11588",
  "icons": "/icons/static-2.627",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6998",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3695",
  "property-translator": "/property-translator/static-1.5248",
  "quartz-config": "/quartz-config/static-1.561",
  "quartz-core": "/quartz-core/static-1.6002",
  "quick-fetch": "/quick-fetch/static-1.3776",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5212",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8001",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
  "report-customization-components": "/report-customization-components/static-1.12624",
  "reporting-enablement": "/reporting-enablement/static-1.22214",
  "reporting-reports": "/reporting-reports/static-1.66364",
  "reporting-snowflake": "/reporting-snowflake/static-1.55304",
  "reporting-ui-components": "/reporting-ui-components/static-2.63957",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4476",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8774",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8957",
  "sanitize": "/sanitize/static-1.4313",
  "sanitize-text": "/sanitize-text/static-1.7984",
  "self-service-api": "/self-service-api/static-1.10079",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1589",
  "signup-constants": "/signup-constants/static-1.18500",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20510",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7874",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4609",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10832",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10983",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9384",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17709",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10758",
  "ui-images": "/ui-images/static-2.1107",
  "UIComponents": "/UIComponents/static-3.8227",
  "usage-tracker": "/usage-tracker/static-1.7174",
  "usage-tracker-container": "/usage-tracker-container/static-1.7164",
  "usage-tracker-core": "/usage-tracker-core/static-1.7024",
  "usage-tracker-public": "/usage-tracker-public/static-1.6985",
  "viral-links-lib": "/viral-links-lib/static-1.6878",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3267",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3060",
  "quartz-webpack": "/quartz-webpack/static-1.3007",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8456",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4679",
  "foundations-theming": "/foundations-theming/static-1.4250",
  "quartz-auth": "/quartz-auth/static-1.458",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8870",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4860",
  "foundations-theming-base": "/foundations-theming-base/static-1.3235",
  "HeadJS": "/HeadJS/static-2.719",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2956",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4165",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7763",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3458",
  "persist-promise": "/persist-promise/static-1.3547",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.623",
  "hs-story-utils": "/hs-story-utils/static-1.9265",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9564",
  "hubspotter-http": "/hubspotter-http/static-1.4516",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7087",
  "crm-message-bus": "/crm-message-bus/static-1.42479",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21478",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12850",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12986",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9663",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3871",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6616",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6711",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3712",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.812",
  "onboarding-tours": "/onboarding-tours/static-1.16317",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13170",
  "ui-addon-teams": "/ui-addon-teams/static-1.21291",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67735",
  "customer-data-properties": "/customer-data-properties/static-1.50879",
  "forms-ai-lib": "/forms-ai-lib/static-1.4066",
  "forms-utils-lib": "/forms-utils-lib/static-1.12237",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5081",
  "react-dnd-compat": "/react-dnd-compat/static-1.4459",
  "react-tinymce": "/react-tinymce/static-1.54727",
  "tinymce-config": "/tinymce-config/static-2.53853",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10186",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3867",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1319",
  "ui-fonts": "/ui-fonts/static-1.542",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.804",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.492",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.448",
  "quartz-i18n": "/quartz-i18n/static-1.458",
  "quartz-routing": "/quartz-routing/static-1.213",
  "quartz-test": "/quartz-test/static-1.458",
  "quartz-tracking": "/quartz-tracking/static-1.162",
  "batch-promise": "/batch-promise/static-1.1390",
  "external-options-client-types": "/external-options-client-types/static-1.4022",
  "react-colorpicker": "/react-colorpicker/static-2.10050",
  "copilot-toolkit": "/copilot-toolkit/static-1.10630",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12412",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6302",
  "reporting-action-components": "/reporting-action-components/static-1.40753",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1217",
  "reporting-plugins": "/reporting-plugins/static-1.10024",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4093",
  "ui-addon-opt": "/ui-addon-opt/static-4.8224",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9985",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24836",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4719",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4030",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5528",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3943",
  "timezone-utils": "/timezone-utils/static-2.5083",
  "bender-build-tools": "/bender-build-tools/static-1.2988",
  "chatspot-core": "/chatspot-core/static-1.20485",
  "chirp-fetch": "/chirp-fetch/static-1.1721",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2733",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9562",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3661",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4003",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3554",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17989",
  "growth-data-modal": "/growth-data-modal/static-1.5197",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2911",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1394",
  "navigation-components": "/navigation-components/static-1.17401",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4531",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.383",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7366",
  "ui-universal-auth": "/ui-universal-auth/static-1.8755",
  "user-context": "/user-context/static-1.4939",
  "cms-field-types": "/cms-field-types/static-1.4647",
  "content-icons-ui": "/content-icons-ui/static-1.2169",
  "integrations-lib": "/integrations-lib/static-1.15553",
  "calling-global-api": "/calling-global-api/static-1.63806",
  "calling-internal-common": "/calling-internal-common/static-1.31134",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65188",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57482",
  "commerce-products-lib": "/commerce-products-lib/static-1.8960",
  "crm-links": "/crm-links/static-1.6106",
  "file-manager-components": "/file-manager-components/static-1.23015",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.520",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4086",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.471",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48126",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3827",
  "property-value-citations": "/property-value-citations/static-1.1493",
  "pulse": "/pulse/static-1.355",
  "smart-property-lib": "/smart-property-lib/static-1.6091",
  "tiered-pricing": "/tiered-pricing/static-1.884",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8886",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19536",
  "tinymce-themes": "/tinymce-themes/static-1.55823",
  "data-token-picker": "/data-token-picker/static-1.16108",
  "hub-http-contrib": "/hub-http-contrib/static-1.2882",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39938",
  "tinymce-plugins": "/tinymce-plugins/static-1.56967",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5053",
  "magpie-lib": "/magpie-lib/static-1.5433",
  "magpie-types": "/magpie-types/static-1.4893",
  "simple-logging-lib": "/simple-logging-lib/static-1.2889",
  "content-assistance-lib": "/content-assistance-lib/static-1.7505",
  "dashboard-lib": "/dashboard-lib/static-1.80783",
  "ExportDialog": "/ExportDialog/static-6.10227",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17706",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17698",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8532",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8400",
  "feedback-loader": "/feedback-loader/static-1.28941",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4490",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.178",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4338",
  "nav-client-types": "/nav-client-types/static-1.2196",
  "purchase-motions-api": "/purchase-motions-api/static-1.5531",
  "trials-service-types": "/trials-service-types/static-1.3739",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1422",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.564",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.550",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17107",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12968",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5427",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7627",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10212",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31140",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10878",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6380",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.359",
  "customer-data-tracking": "/customer-data-tracking/static-1.6721",
  "commerce-permissions": "/commerce-permissions/static-1.600",
  "products-iframe-lib": "/products-iframe-lib/static-1.7432",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9946",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8682",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3993",
  "video-components-external": "/video-components-external/static-1.10683",
  "video-data-lib": "/video-data-lib/static-1.34341",
  "directed-graph": "/directed-graph/static-1.778",
  "event-emitter": "/event-emitter/static-1.786",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5379",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9647",
  "fsm": "/fsm/static-1.3570",
  "policy-lib": "/policy-lib/static-1.6616",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9710",
  "navigation-messaging": "/navigation-messaging/static-1.6728",
  "FileManagerLib": "/FileManagerLib/static-1.38655",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8934",
  "FileManagerCore": "/FileManagerCore/static-1.38514",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12108",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11083",
  "react-codemirror": "/react-codemirror/static-1.10465",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9726",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14147",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8535",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28046",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8406",
  "payment-link-components": "/payment-link-components/static-1.23042",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3020",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2837",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35136",
  "sales-views-client-types": "/sales-views-client-types/static-1.4125",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3481",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11587",
  "content-media-compositions": "/content-media-compositions/static-2.15594",
  "media-bridge-lib": "/media-bridge-lib/static-1.18630",
  "trellis-story-utils": "/trellis-story-utils/static-1.4359",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5669",
  "FileManagerImages": "/FileManagerImages/static-1.36166",
  "video-components": "/video-components/static-1.12686",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4370",
  "video-embed": "/video-embed/static-1.35175",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67810",
  "layout-data-lib": "/layout-data-lib/static-1.9408",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6420",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5773",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4925",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3506",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21373",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3682",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21470",
  "outpost": "/outpost/static-1.4040",
  "advanced-menus-core": "/advanced-menus-core/static-1.14874",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11844",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33553",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14873",
  "simple-menus-lib": "/simple-menus-lib/static-1.16390"
}
};
